<template>
  <div class="container">
    <div v-if="loading" class="center">
      <p class="loading-text">正在加载中...</p>
    </div>
    <div v-else-if="errorCode === -2" class="center">
      <div class="row">
        <input v-model="userNum" class="input" placeholder="编号" />
      </div>
      <div class="row">
        <input v-model="userName" class="input" placeholder="姓名" />
      </div>
      <div class="row">
        <button @click="bindWxUserKey" class="button">绑定</button>
      </div>
    </div>
    <div v-else class="center">
      <div class="row">
        <img v-if="errorCode === 0" src="/success.png" alt="Success" class="icon" />
        <img v-else src="/error.png" alt="Error" class="icon" />
        <p class="message-text">{{ message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';

export default {
  data () {
    return {
      loading: true,
      errorCode: null,
      message: '',
      serverId: null,
      userNum: '',
      userName: '',
      openId: '',
    };
  },
  methods: {
    async devBindWxUserKey () {
      this.serverId = 1;
      this.openId = "ojeMP6z2IywJN-vWbU5c5RrKJCfA";
      this.errorCode = -2;
      this.message = "";
      this.loading = false;
    },
    async fetchBindCallback () {
      const route = useRoute();
      const { serverId, code, state } = route.query;
      if (serverId) {
        const newUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx04b71f93bc2eb66d&redirect_uri=https%3A%2F%2Fwx.whltcd.com%2F2&response_type=code&scope=snsapi_base&state=${serverId}#wechat_redirect`;
        window.location.href = newUrl;
      } else if (code && state) {
        this.loading = true;
        this.errorCode = -2;
        this.serverId = state;
        this.openId = code;
        this.loading = false;
      } else {
        this.message = '参数错误';
        this.loading = false;
      }
    },
    async bindWxUserKey () {
      if (this.userNum && this.userName) {
        this.loading = true;
        this.errorCode = -1;
        try {
          const response = await fetch('/api/app/iot/wx/bindWxUserKey', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ serverId: this.serverId, userNum: this.userNum, userName: this.userName, openId: this.openId }),
          });
          const r = await response.json();
          console.log(r);
          this.message = r.data.msg;
          this.errorCode = r.data.code;
          this.loading = false;
        } catch (error) {
          this.message = '绑定失败';
          this.loading = false;
        }
      } else {
        alert('请输入编号和姓名');
      }
    },
  },
  mounted () {
    if (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('127.0.0.1') > -1) {
      this.devBindWxUserKey();
    } else {
      this.fetchBindCallback();
    }
  },
};
</script>

<style scoped>
.container {
  margin-top: 50px;
  justify-content: center;
  align-items: center;
  height: 80vh;
  font-size: 25px;
}

.center {
  text-align: center;
}

.row {
  margin-bottom: 20px;
}

.input {
  padding: 8px;
  width: 280px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 36px;
}

.button {
  padding: 8px 16px;
  width: 300px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 36px;
}

.message-text {
  font-size: 28px;
}

.icon {
  max-width: 80px;
  max-height: 80px;
  width: auto;
  height: auto;
}
</style>
